export default __webpack_public_path__ + "static/media/Example1.c33b0fe8.jpeg";